import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';

class DisputesApi extends Api{

    
    static createDispute(data = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_DISPUTES;
        options.data = data;
        return request.post(options);
    }

    static reOpenDispute(logCode, data = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES}/${logCode}/reopen`;
        options.data = data;
        return request.post(options);
    }
    static updateDispute(logCode, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES}/${logCode}`;
        options.data = data;
        return request.patch(options);
    }

    static findDisputes(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_DISPUTES;
        options.params = params;
        return request.get(options);
    }

    static getDispute(logCode){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES}/${logCode}`;
        options.params = {};
        return request.get(options);
    }

     static getDisputeSettlements(logCode){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES}/${logCode}/settlements`;
        options.params = {};
        return request.get(options);
    }

    static getDisputeReOpenTransaction(logCode){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES}/${logCode}/reopen`;
        options.params = {};
        return request.get(options);
    }
}

export default DisputesApi;


// WEBPACK FOOTER //
// ./src/api/DisputesApi.js